var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { staticClass: "row bg-white", attrs: { show: _vm.loading } },
    [
      _c("div", { staticClass: "col-12 mt-3" }, [
        _vm._v(
          " ¿Estás seguro de que quieres devolver el Lote Nº " +
            _vm._s(_vm.batch.folio) +
            "? "
        )
      ]),
      _c(
        "div",
        { staticClass: "col-12 mt-3" },
        [
          _c(
            "b-form",
            { attrs: { id: "form-message", "data-vv-scope": "form-message" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Motivo por el que se devuelve el lote",
                            "label-for": "#"
                          }
                        },
                        [
                          _c("SelectValidate", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              options: _vm.optionReturnType,
                              name: "return",
                              danger: _vm.errors.has("form-message.return"),
                              "danger-text": _vm.errors.first(
                                "form-message.return"
                              ),
                              "data-vv-as": "motivo de devolución",
                              state: _vm.errors.has("form-message.return")
                                ? false
                                : null
                            },
                            model: {
                              value: _vm.cause,
                              callback: function($$v) {
                                _vm.cause = $$v
                              },
                              expression: "cause"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("vs-divider"),
      _c(
        "b-col",
        { staticClass: "text-right", attrs: { cols: "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: { variant: "primary", "data-cy": "cancel-batch" },
              on: { click: _vm.onReturn }
            },
            [_vm._v(" Si, Estoy seguro! ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }